import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Resource, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  assignPersonalCalendarHolidays(
    request: Boundaries["assignPersonalCalendarHolidays"]["request"],
  ): void;
}

function useAssignPersonalCalendarHolidays(
  resource: Identifiable<Resource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isAssignPersonalCalendarHolidaysRequestPending(resource),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isAssignPersonalCalendarHolidaysRequestSuccess(resource),
    ),
    isRequestFailure: useSelector(() =>
      selector.isAssignPersonalCalendarHolidaysRequestFailure(resource),
    ),
    assignPersonalCalendarHolidays: core.assignPersonalCalendarHolidays,
  };
}

export { useAssignPersonalCalendarHolidays };
